import axios, { AxiosError } from 'axios';
import { conexao } from '../../../../offline/conexao';


export const errorInterceptor = (error: AxiosError) => {

  // Sem resposta do servidor (rede caída, timeout) — o sistema passa a
  // trabalhar offline (ver shared/offline). Com resposta, está alcançável.
  if (!axios.isCancel(error)) {
    if (error.response) conexao.marcarOnline();
    else if (error.request) conexao.marcarOffline();
  }

  if (error.message === 'Network Error') {
    return Promise.reject(new Error('Erro de conexão.'));
  }

  // ApiLogin é usado exclusivamente para autenticar (POST /login), então um
  // 401 aqui é sempre "credenciais inválidas" e nunca "sessão expirada" —
  // não deve redirecionar/recarregar a página, apenas rejeitar para o
  // Login.tsx exibir a mensagem de erro.
  return Promise.reject(error);
};